import { Component, EventEmitter, Input, Output } from '@angular/core';

// TODO this type is not used elsewhere
//export type BtnConfig = {
//	name: string
//	class: string
//	isTranslateAble: true | false
//	color: 'primary' | 'accent' | 'warn'
//}

@Component({
	selector: 'cass-upload-material',
	templateUrl: './upload-material.component.html',
	styleUrls: ['./upload-material.component.css']
})
export class UploadMaterialComponent {

	@Input()
	isMultiple: boolean = false

	@Input('uploadProgress')
	progress: number | undefined;

	@Input()
	set isProcessing(val: boolean | undefined) {
		if (val) {
			this.progressBarMode = "indeterminate";
			this.progressLabelKey = "ORDER_BASKET.MATERIAL_PREVIEW_DIALOG.ACTION.PROCESSING";
		}
		else {
			this.progressBarMode = "determinate";
			this.progressLabelKey = "ORDER_BASKET.MATERIAL_PREVIEW_DIALOG.ACTION.UPLOADING";
		}
	}

	@Output()
	uploadFile = new EventEmitter<any>();

	@Output()
	findMaterialClickEvent = new EventEmitter<any>()

	files: File[] | any = [];
	progressBarMode: "determinate" | "indeterminate" = "determinate";
	progressLabelKey: string = "";

	constructor () { }

	formatBytes(bytes: any, decimals?: any) {
		if (bytes === 0) {
			return '0 Bytes';
		}
		const k = 1024;
		const dm = decimals <= 0 ? 0 : decimals || 2;
		const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
		const i = Math.floor(Math.log(bytes) / Math.log(k));
		return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
	}

	prepareFilesList(files: Array<any>) {
		for (const item of files) {
			item.progress = 0;
			this.files.push(item);
		}
	}

	deleteFile(index: number) {
		this.files.splice(index, 1);
	}

	fileBrowseHandler(event: any) {
		this.prepareFilesList(event.target.files);
	}

	onFileDropped($event: any) {
		this.prepareFilesList($event);
	}

	//public reset() {
	//	this.progress = undefined;
	//}

	emitUploadFile(i: number) {
		this.uploadFile.emit(this.files[i])
	}

	emitFindMaterialClickEvent(event: MouseEvent) {
		this.findMaterialClickEvent.emit(event);
	}
}
